import { SurveySection } from "@/features/survey/types";
import { useLayoutEffect, useRef, useState } from "react";

interface MenuItem {
  path: string;
  label: string;
  isCustom?: boolean;
  section?: SurveySection;
  order?: number;
  name?: string;
}

export const useMenuOverflow = (menuItems: MenuItem[]) => {
  const navRef = useRef<HTMLElement>(null);
  const leftNavRef = useRef<HTMLDivElement>(null);
  const rightNavRef = useRef<HTMLDivElement>(null);
  const cbreLogoRef = useRef<HTMLDivElement>(null);
  const [updatedMenuItems, setUpdatedMenuItems] = useState<MenuItem[]>([]);
  const [overflowSections, setOverflowSections] = useState<MenuItem[]>([]);

  useLayoutEffect(() => {
    if (!navRef.current || !leftNavRef.current || !rightNavRef.current) return;

    const availableWidth = navRef.current.offsetWidth;
    const leftWidth = leftNavRef.current.offsetWidth;
    const rightWidth = rightNavRef.current.offsetWidth;
    const cbreLogoWidth = cbreLogoRef.current?.offsetWidth ?? 0;
    const allMargins = 100;
    const navItems = leftNavRef.current.querySelectorAll(".nav-item");

    let modifiedWidth = rightWidth + cbreLogoWidth + allMargins;

    if (availableWidth < leftWidth + rightWidth + allMargins) {
      navItems.forEach((item, index) => {
        const element = window.getComputedStyle(item);
        const elementMargin =
          parseFloat(element.marginLeft) + parseFloat(element.marginRight);
        modifiedWidth += elementMargin + item.clientWidth;

        if (availableWidth > modifiedWidth) {
          setUpdatedMenuItems(menuItems.slice(0, index));
          setOverflowSections(menuItems.slice(index));
        }
      });
    } else {
      setUpdatedMenuItems([]);
      setOverflowSections([]);
    }
  }, [menuItems]);

  return {
    navRef,
    leftNavRef,
    rightNavRef,
    cbreLogoRef,
    updatedMenuItems,
    overflowSections,
  };
};
